import { motion } from "framer-motion";
import ollieFloating from "../../shared/assets/img/ollie/floating/ollie-floating.svg";

interface OllieFloatingProps {
    size?: "small" | "medium" | "large";
    className?: string;
}

const sizeClasses = {
    small: "w-24 h-24",
    medium: "w-32 h-32",
    large: "w-48 h-48",
}

const shadowClasses = {
    small: "top-[85px] w-10 h-2",
    medium: "top-[120px] w-16 h-4",
    large: "top-[140px] w-32 h-8",
}

export const OllieFloating = ({ className, size = "medium" }: OllieFloatingProps) => {
    return (
        <motion.div className={`relative flex flex-col items-center justify-center ${className}`} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1 }}>
            <motion.img
                src={ollieFloating}
                alt="ollie"
                className={`${sizeClasses[size]} z-10`}
                animate={{
                    y: [0, -5, 0]
                }}
                transition={{
                    duration: 3,
                    repeat: Infinity,
                    ease: "easeInOut"
                }}
            />
            {/* Shadow ellipse */}
            <motion.div
                className={`absolute left-1/2 -translate-x-1/2  ${shadowClasses[size]} bg-black/25 rounded-full blur-sm`}
                animate={{
                    scaleX: [1, 1.1, 1],
                    scaleY: [1, 1.05, 1],
                    opacity: [0.8, 0.6, 0.8],
                }}
                transition={{
                    duration: 3,
                    repeat: Infinity,
                    ease: "easeInOut",
                }}
            />
        </motion.div>
    );
};
